export default __webpack_public_path__ + "static/media/Label_Shopping_inv.0d844bd5.png";